module.exports = __webpack_public_path__ + "static/media/Installment payment_V6.2f298cb6.jpg";